/* ==========================================================================
   TodoTecno Global - Theme JavaScript
   Mobile nav, smooth scroll, and AJAX add-to-cart with inline errors.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  /* ---------- Mobile Nav Toggle ---------- */
  const mobileToggle = document.querySelector('.js-mobile-nav-toggle');
  const siteNav = document.querySelector('#SiteNav');
  if (mobileToggle && siteNav) {
    mobileToggle.addEventListener('click', () => {
      const isVisible = siteNav.style.display === 'block';
      siteNav.style.display = isVisible ? 'none' : 'block';
    });
  }

  /* ---------- Smooth scroll for in-page anchors ---------- */
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      const hash = this.getAttribute('href');
      if (!hash || hash.length < 2) return;
      const target = document.querySelector(hash);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  /* ---------- AJAX add to cart ---------- */
  const cartCountEls = document.querySelectorAll('.cart-link__count');

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        cartCountEls.forEach((el) => { el.textContent = cart.item_count; });
      })
      .catch(() => {});
  }

  function setFeedback(form, message, ok) {
    let box = form.querySelector('.form-feedback');
    if (!box) {
      box = document.createElement('div');
      box.className = 'form-feedback';
      box.setAttribute('role', 'status');
      form.appendChild(box);
    }
    box.classList.toggle('form-feedback--error', !ok);
    box.classList.toggle('form-feedback--ok', ok);
    if (ok) {
      box.innerHTML = message + ' <a href="/cart">Ver carrito &rarr;</a>';
    } else {
      box.textContent = message;
    }
    box.hidden = false;
  }

  const cartForms = document.querySelectorAll('form[action$="/cart/add"]');
  cartForms.forEach((form) => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalHTML = btn ? btn.innerHTML : '';
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = 'Agregando…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(new FormData(form)).toString()
      })
        .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) {
            throw new Error(data.description || data.message || 'No se pudo agregar el producto.');
          }
          refreshCartCount();
          if (btn) btn.innerHTML = '✓ Agregado';
          setFeedback(form, 'Producto agregado al carrito.', true);
          setTimeout(() => {
            if (btn) {
              btn.innerHTML = originalHTML;
              btn.disabled = false;
            }
          }, 2200);
        })
        .catch((err) => {
          setFeedback(form, err.message, false);
          if (btn) {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }
        });
    });
  });
});
